import { render } from "./Sensores.vue?vue&type=template&id=07be8142&scoped=true"
import script from "./Sensores.vue?vue&type=script&lang=js"
export * from "./Sensores.vue?vue&type=script&lang=js"

import "./Sensores.vue?vue&type=style&index=0&id=07be8142&scoped=true&lang=css"
import "./Sensores.vue?vue&type=style&index=1&id=07be8142&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07be8142"]])

export default __exports__